import React from 'react';
import * as styles from './logo-garden.module.css';
import {
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    getDisplayDimensions,
} from '../Global/DataUtils';

interface LogoProps {
    logoUrl: string;
    logoDescription: string;
    logoTarget: 'same_window' | 'new_window';
    logoLink?: string;
    lessThan4?: boolean;
    lessThan6?: boolean;
    logoWidth?: number;
    logoHeight?: number;
}

const Logo: React.FC<LogoProps> = ({
    logoUrl,
    logoDescription,
    logoTarget,
    logoLink,
    lessThan4,
    lessThan6,
    logoWidth,
    logoHeight,
}) => {
    const target = logoTarget === 'same_window' ? '_self' : '_blank';

    return (
        <div
            className={`${styles.logoContainer} ${
                logoLink ? styles.zoomEffect : ''
            } ${lessThan4 ? styles.largeLogosize : ''} ${
                lessThan6 ? styles.logoalignment : ''
            }`}
            data-kontent-element-codename="image"
        >
            {!logoLink ? (
                <img
                    src={optimizeKontentImageUrl(logoUrl, {
                        w: 200,
                        fm: 'webp',
                        q: 80,
                    })}
                    srcSet={buildKontentSrcSet(logoUrl, 200, {
                        fm: 'webp' as const,
                        q: 80,
                    })}
                    sizes="200px"
                    alt={logoDescription}
                    {...getDisplayDimensions(logoWidth, logoHeight, 200)}
                    loading="lazy"
                />
            ) : (
                <a
                    href={logoLink}
                    target={target}
                    rel={
                        target === '_blank' ? 'noopener noreferrer' : undefined
                    }
                    aria-label={logoDescription || 'Partner logo'}
                >
                    <img
                        src={optimizeKontentImageUrl(logoUrl, {
                            w: 200,
                            fm: 'webp',
                            q: 80,
                        })}
                        srcSet={buildKontentSrcSet(logoUrl, 200, {
                            fm: 'webp' as const,
                            q: 80,
                        })}
                        sizes="200px"
                        alt={logoDescription}
                        {...getDisplayDimensions(logoWidth, logoHeight, 200)}
                        loading="lazy"
                    />
                </a>
            )}
        </div>
    );
};

export default Logo;
